/* eslint-disable no-restricted-syntax */

import Immutable from 'immutable';
import { ADD_NOTIFICATION_EVENTS } from './actions';
import {
  NOTIFICATION_READ_FETCH_SUCCESS,
  NOTIFICATION_READ_REFRESH_SUCCESS,
  NOTIFICATION_READ_LOAD_MORE_SUCCESS,
  NOTIFICATION_UNREAD_FETCH_SUCCESS,
  NOTIFICATION_UNREAD_REFRESH_SUCCESS,
  NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS,
  NOTIFICATION_RESET,
} from '../Notifications/actions';
import { FETCH_NOTIFICATION_DETAIL_SUCCESS } from '../PushNotification/actions';
import { GET_LINKED_NOTIFICATION_DATA } from '../LinkedNotification/actions';
import { LOGOUT_SUCCESS } from '../Auth/actions';

const INITIAL_STATE = Immutable.fromJS({
  byId: {},
  byChannel: {},
});

export function NotificationEvents(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_LINKED_NOTIFICATION_DATA:
    case NOTIFICATION_READ_FETCH_SUCCESS:
    case NOTIFICATION_READ_REFRESH_SUCCESS:
    case NOTIFICATION_READ_LOAD_MORE_SUCCESS:
    case NOTIFICATION_UNREAD_FETCH_SUCCESS:
    case NOTIFICATION_UNREAD_REFRESH_SUCCESS:
    case NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS:
    case FETCH_NOTIFICATION_DETAIL_SUCCESS:
    case ADD_NOTIFICATION_EVENTS: {
      const notificationEvents = Immutable.fromJS(action.notificationEvents);
      let updatedState = state;
      for (const event of notificationEvents.values()) {
        updatedState = updatedState.setIn(['byId', event.get('id')], event);
        updatedState = updatedState.setIn(
          ['byChannel', event.get('channelId'), event.get('eventIndex')],
          event
        );
      }
      return updatedState;
    }
    case NOTIFICATION_RESET:
    case LOGOUT_SUCCESS: {
      return INITIAL_STATE;
    }
    default: {
      return state;
    }
  }
}
